import { ContainerDesktop } from "components/Container";
import { Logo } from "components/Logo";
import { useSystemStore } from "components/PageHeader/systemStore";
import { useIsDesktop } from "lib/device";
import Image from "next/image";
import React from "react";

const FooterBusiness: React.FC = ({}) => {
  const isDesktop = useIsDesktop();
  const [theme] = useSystemStore((state) => [state.theme]);

  return (
    <footer>
      <ContainerDesktop className="flex" useAuto>
        {!isDesktop ? (
          <div className="flex flex-col justify-between items-center w-full gap-12 pb-[24px] text-violet-100">
            <Image
              src={"/logo-1024.png"}
              alt="learnext_logo"
              width={135}
              height={36}
              className={theme === "dark" ? "invert brightness-0" : ""}
            />
            <div className="font-light">
              AI-Powered Learning for Professionals
            </div>
            <div className="font-light text-b1">
              © {new Date().getFullYear()} PT. Sistem Sarjana Sejahtera.
            </div>
          </div>
        ) : (
          <div className="flex flex-row justify-between items-center w-full gap-12 text-violet-100 py-[24px]">
            <div className="font-light">
              AI-Powered Learning for Professionals
            </div>
            <Image
              src={"/logo-1024.png"}
              alt="learnext_logo"
              width={135}
              height={36}
              className={theme === "dark" ? "invert brightness-0" : ""}
            />
            <div className="font-light text-b1">
              © {new Date().getFullYear()} PT. Sistem Sarjana Sejahtera.
            </div>
          </div>
        )}
      </ContainerDesktop>
    </footer>
  );
};

export default FooterBusiness;
